import React from 'react';

type AtMentionIconProps = {
  width?: number | string;
  height?: number | string;
  className?: string;
};

const AtMentionIcon = ({
  width = 24,
  height = 24,
  className = '',
}: AtMentionIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <path
      d="M16 12a4 4 0 1 0-8 0 4 4 0 0 0 8 0Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 12v1.75a2.75 2.75 0 0 0 5.5 0V12a8.75 8.75 0 1 0-8.75 8.75"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default AtMentionIcon;
